var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rep-coverage-widget"},[_c('canvas',{attrs:{"id":_vm.chartId,"width":"100%","height":"auto"}}),_c('div',{staticClass:"legend"},[_c('strong',[_vm._v("Gecoverd: "+_vm._s(_vm.target.covered))]),_c('strong',[_vm._v("Niet gecoverd: "+_vm._s(_vm.notVisited))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }